import { dew as _ClientDew } from "../Client";
import { dew as _environmentsDew } from "../environments";
import * as _urlJoin2 from "url-join";
var _urlJoin = "default" in _urlJoin2 ? _urlJoin2.default : _urlJoin2;
import * as _crossEnvConfig2 from "@flatfile/cross-env-config";
var _crossEnvConfig = "default" in _crossEnvConfig2 ? _crossEnvConfig2.default : _crossEnvConfig2;
import { dew as _RecordsClientDew } from "./RecordsClient";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });
  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.FlatfileClient = void 0;
  const Client_1 = _ClientDew();
  const environments = __importStar(_environmentsDew());
  const url_join_1 = __importDefault(_urlJoin);
  const cross_env_config_1 = _crossEnvConfig;
  const RecordsClient_1 = _RecordsClientDew();
  cross_env_config_1.CrossEnvConfig.alias("FLATFILE_API_URL", "AGENT_INTERNAL_URL");
  cross_env_config_1.CrossEnvConfig.alias("FLATFILE_BEARER_TOKEN", "FLATFILE_API_KEY");
  class FlatfileClient extends Client_1.FlatfileClient {
    constructor(options = {}) {
      var _a, _b;
      super({
        environment: (_a = options.environment || options.apiUrl) !== null && _a !== void 0 ? _a : environmentSupplier,
        token: (_b = options.token) !== null && _b !== void 0 ? _b : tokenSupplier
      });
    }
    get records() {
      var _a;
      return (_a = this._records) !== null && _a !== void 0 ? _a : this._records = new RecordsClient_1.Records(this._options);
    }
  }
  exports.FlatfileClient = FlatfileClient;
  const environmentSupplier = () => {
    const url = cross_env_config_1.CrossEnvConfig.get("FLATFILE_API_URL");
    if (!url) {
      return environments.FlatfileEnvironment.Production;
    }
    return (0, url_join_1.default)(url, "v1");
  };
  const tokenSupplier = () => {
    const token = cross_env_config_1.CrossEnvConfig.get("FLATFILE_BEARER_TOKEN");
    if (token == undefined) {
      throw new Error("FLATFILE_BEARER_TOKEN is not undefined");
    }
    return token;
  };
  return exports;
}